import { Injectable } from '@angular/core';
import { FormSubmission, FormsSubmissionsParams } from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { FormsService } from './forms.interface';

@Injectable({
  providedIn: 'root',
})
export class FormsServiceApi
  extends HttpService<FormSubmission>
  implements FormsService
{
  protected override collectionPath = '/forms/submissions';

  getForms(
    params: FormsSubmissionsParams = { limit: 5 }
  ): Observable<FormSubmission[]> {
    return this.http.get<FormSubmission[]>(this.apiUrl, {
      params: this.getHttpParameters(
        params as Record<string, string | number | boolean | undefined>
      ),
    });
  }

  /**
   * GET /patients/{patientId}/forms/submissions
   */
  getPatientFormsSubmissions(
    patientId: string,
    params?: {
      limit?: number;
      type?: string | undefined;
    }
  ): Observable<FormSubmission[]> {
    return this.http.get<FormSubmission[]>(
      `${this.apiRootUrl}/patients/${patientId}/forms/submissions`,
      {
        params: this.getHttpParameters(params),
      }
    );
  }
}
